import { api } from '../../api/client'

const BASE = '/compliance'

export class ComplianceApi {
  static async downloadJobFile(jobId) {
    return await api.get(`${BASE}/download/${jobId}`, { responseType: 'blob' })
  }
}
